<template>
  <BaseLimitManagement
    :items="items"
    :selected="itemsSelected"
    :loading="loading"
    @delete="deleteSelected"
  >
    <template v-slot:listItem="{ item }">
      <v-checkbox
        :input-value="item.selected"
        @change="selectItem(item)"
      ></v-checkbox>
      <div class="content-wrapper">
        <v-icon v-if="item.is_auto_categorized" color="black">
          icon-robot
        </v-icon>
        <div>
          {{ item.name }}
        </div>
      </div>
    </template>
  </BaseLimitManagement>
</template>

<script>
import limitsService from "@/services/limits";
import BaseLimitManagement from "./BaseLimitManagement.vue";
import { limitsMixin } from "@/helpers/mixins/limits";

export default {
  name: "LimitManagement",
  components: {
    BaseLimitManagement
  },
  mixins: [limitsMixin],
  methods: {
    itemsFetchHandler() {
      return limitsService.getTags();
    },
    itemDeleteHandler(id) {
      return limitsService.deleteTag(id);
    }
  }
};
</script>

<style lang="scss" scoped>
.content-wrapper {
  width: 100%;
  margin-left: $spacing;
  display: flex;
  align-items: center;
  gap: $spacing;
}
</style>
